const zoomLevels = [0.5, 0.75, 1, 1.25, 1.5, 1.75, 2, 2.5, 3];

export default function getNextZoomLevel(zoom: number, zoomDelta: number) {
    return zoomLevels[zoomLevels.indexOf(zoom) + zoomDelta] || zoom;
}
